$(function () {
  if (localStorage.getItem('collapsed') === "true") {
    document.body.classList.add('sidebar-collapse');
  } else {
    document.body.classList.remove('sidebar-collapse');
  }
});

window.updateQueryStringPerPageParam = function () {
  var baseUrl = [location.protocol, '//', location.host, location.pathname].join(''),
    urlQueryString = document.location.search,
    newParam = 'per_page=' + $('#rows').val(),
    params = '?' + newParam;

  // If the "search" string exists, then build params from it
  if (urlQueryString) {
    keyRegex = new RegExp('([\?&])per_page[^&]*');

    // If param exists already, update it
    if (urlQueryString.match(keyRegex) !== null) {
      params = urlQueryString.replace(keyRegex, "$1" + newParam);
    } else { // Otherwise, add it to end of query string
      params = urlQueryString + '&' + newParam;
    }
  }
  
  window.location.href = baseUrl + params;
}
